import "rc-slider/assets/index.css";
import "rc-tooltip/assets/bootstrap.css";
import TenantDetailsHeader from "../../components/TenantDetails/TenantDetailsHeader";
import useTranslator from "../../hooks/useTranslator";
import DetailsSkor from "../../components/TenantDetails/DetailsSkor";
import DetailsDocs from "../../components/TenantDetails/DetailsDocs";
import DataInfoModal from "../../components/TenantDetails/DataInfoModal";
import DetailsEmploymentInfo from "../../components/TenantDetails/DetailsEmploymentInfo";
import DetailsPersonalInfo from "../../components/TenantDetails/DetailsPersonalInfo";
import DetailsIncomeInfo from "../../components/TenantDetails/DetailsIncomeInfo";
import SkorAi from "../../assets/img/skorAI_logo.gif";
import SkorAi2 from "../../assets/img/skorAI_logo2.gif";
import { useContext, useEffect, useState } from "react";
import AuthContext from "../../context/auth/AuthContext";
import {
  calculateEffortRate,
  calculateEffortRatePercentageTenant,
  getCustomIncomeDetails,
  getIdentityDetails,
  haveValue,
  nl2ul,
  resolveIncomeSelection,
  toast,
} from "../../helper/common";
import { useLocation, useNavigate } from "react-router-dom";
import axiosInstance from "../../services/authWrapper";
import Loader from "../../components/Loader";
import LandLordContext from "../../context/landlord/LandLordContext";
import UpdatedIncomeSourceModal from "../../components/TenantDetails/UpdateIncomeSourceModal";
import DefaultCheckReportModal from "../../components/TenantDetails/DefaultCheckReportModal";
import GuarantorDetails from "../../components/TenantDetails/GuarantorDetails";
import PendingRequestsPopup from "../../components/Tenant/Guarantor/PendingRequestsPopup";
import axiosInstanceInstance from "../../services/authWrapper";
import { useCookies } from "react-cookie";
import TenantContext from "../../context/tenant/TenantContext";
import RequestAcceptingModal from "../../components/Tenant/Guarantor/RequestAcceptingModal";

function SkorList2(props) {
  const {
    setUserMaxRent = () => {},
    showReportIcons = true,
    reportGuarantorIds,
    participantTenantId,
  } = props;
  const { _t } = useTranslator();
  const navigate = useNavigate();

  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const {
    getAllData,
    checkIeDetails,
    user: originalUser,
    loadUserTenant,
    getPendingGuaantees,
    updateProfile,
  } = useContext(AuthContext);
  const {
    saveRentPercentage,
    changeIncomeSource,
    changeFinancialIncomeSource,
    addCustomIncomeSource,
    deleteCustomIncomeSource,
    deaWorkspace,
  } = useContext(LandLordContext);
  const isDeaRulesActivated =
    originalUser?.current_workspace?.dea_rules_activated === true &&
    deaWorkspace;
  const { shareProfile, saveEffortRateData } = useContext(TenantContext);
  const queryParameters = new URLSearchParams(window.location.search);
  const sharedprofileid = haveValue(props?.sharedprofileid)
    ? props.sharedprofileid
    : queryParameters.get("sharedprofileid");
  const agencylink = haveValue(props?.agencylink)
    ? props.agencylink
    : queryParameters.get("agencylink");
  const guarantor_id = haveValue(props?.guarantor)
    ? props.guarantor
    : queryParameters.get("guarantor");
  // const makeGuarantor = queryParameters.get("sendRequest");
  const tenant_id = haveValue(props?.tenant_id)
    ? props.tenant_id
    : queryParameters.get("tenant_id");
  const isGuarantor = haveValue(guarantor_id);
  const usertype = localStorage.getItem("usertype");
  const llShowOnly =
    localStorage.getItem("usertype") == "landlord" ||
    localStorage.getItem("usertype") == "admin";
  const [fullinfo, setFullinfo] = useState({});
  const [user, setUser] = useState({});
  const [loading, setLoading] = useState(false);
  const [fullInfoForGurantor, setFullInfoForGurantor] = useState({});
  const [forensicAnalysis, setForensicAnalysis] = useState(null);
  const [incomeSources, setIncomeSources] = useState(null);
  const [userIncome, setUserIncome] = useState(null);
  const [gurantorsIncome, setGurantorsIncome] = useState([]);
  const [combinedIncome, setCombinedIncome] = useState(0);
  const [effortObj, setEffortObj] = useState("");
  const [openInfoModal, setOpenInfoModal] = useState(false);
  const [infoModal, setInfoModal] = useState(false);
  const [updateIncomeSourceModal, setUpdateIncomeSourceModal] = useState(false);
  const [showDefaulterCheck, setShowDefaulterCheck] = useState(false);
  const [verifiedDocs, setVerifiedDocs] = useState(new Map());
  const [claveDocs, setClaveDocs] = useState(new Map());
  const [docsMap, setDocsMap] = useState({});
  const [totalIncomeModal, setTotalIncomeModal] = useState(false);
  const [forensicRawData, setForensicRawData] = useState(null);
  const [showChatBot, setShowChatBot] = useState(false);
  const [openGuarantorModel, setOpenGuarantorModel] = useState(false);
  const [uploadDocModel, setUploadDocModel] = useState(false);
  const [
    selectedFinancialIncomeSourceData,
    setselectedFinancialIncomeSourceData,
  ] = useState({});
  const [selectedSources, setSelectedSources] = useState([]);
  const [pendingGuaranteesRequests, setPendingGuaranteesRequests] = useState(
    []
  );
  const [pendingRequestsGuranteesLoading, setPendingRequestsGuranteesLoading] =
    useState(false);
  const [Bankshow, setBankshow] = useState(false);
  const [reconnectFlow, setReconnectFlow] = useState(false);

  // bank account connectivity handling starts
  const error1 = queryParameters.get("error");
  const account_verification_report_id = queryParameters.get(
    "account_verification_report_id"
  );
  const transaction_report_id = queryParameters.get("transaction_report_id");
  const [paymentScoreLoading, setPaymentScoreLoading] = useState(false);
  const [scoreValue, setScoreValue] = useState(null);
  const [financial_info_errors, setFinancial_info_errors] = useState(null);
  const [effortRateType, setEffortRateType] = useState(null);
  const [totalGuarantorIncome, setTotalGuarantorIncome] = useState(null);
  const [showEffortRateCalcuator, setShowEffortRateCalcuator] = useState(false);
  const [cookies, setCookie, removeCookie] = useCookies(["sharedProfileLink"]);

  //accept modal
  const [isAcceptModalOpen, setIsAcceptModalOpen] = useState(false);
  const [acceptedGuaranteeName, setAcceptedGuaranteeName] = useState("");

  // useEffect(() => {
  //   const user_type = localStorage.getItem("usertype");
  //   const userId = localStorage.getItem("saveduserid");
  //   if (haveValue(cookies.requestProfileLink) && user_type == "tenant") {
  //     if (haveValue(userId)) {
  //       const havePropertyId = haveValue(cookies.property_id);
  //       const payload = {
  //         shareType: "lLink",
  //       };
  //       if (havePropertyId) {
  //         payload.property_id = cookies.property_id;
  //       }
  //       shareProfile(
  //         userId,
  //         cookies.requestProfileLink,
  //         "null",
  //         "full",
  //         payload
  //       )
  //         .then((res) => {
  //           removeCookie("requestProfileLink", { path: "/", maxAge: 1800 });
  //           if (havePropertyId) {
  //             removeCookie("property_id", { path: "/", maxAge: 1800 });
  //           }
  //         })
  //         .catch((err) => {});
  //     }
  //   }
  // }, []);

  // Share profile logic ends

  useEffect(() => {
    if (error1) {
      toast.error(_t("bankDetailsCannotBeFetched"));
    }
    if (account_verification_report_id && transaction_report_id) {
      let userid = localStorage.getItem("saveduserid");
      if (!userid) {
        toast.error(_t("userNotAuthorized"));
      } else {
        setScoreValue(null);
        setPaymentScoreLoading(true);
        calculateScore(
          userid,
          account_verification_report_id,
          transaction_report_id
        );
      }
    }
  }, [account_verification_report_id]);

  const updateTenantData = async (data) => {
    let user_id = localStorage.getItem("saveduserid");
    try {
      if (!haveValue(data?.is_edit)) {
        data.is_edit = true;
      }
      await axiosInstance.patch(
        `${process.env.REACT_APP_SERVER_URL}/users/profile/${user_id}`,
        data,
        {
          headers: { "Accept-Language": localStorage.getItem("i18nextLng") },
        }
      );
    } catch (error) {
      console.log("Error updating user");
    }
  };

  const calculateScore = async (
    userid,
    accountverificationid,
    transactionreportid
  ) => {
    await updateTenantData({
      bank_status: true,
      paymentScores: null,
      role: "tenant",
    });
    await clearPaymentData(userid);
    loadFullInfo(false);
    calculatePaymentScore(userid, accountverificationid, transactionreportid);
  };

  const calculatePaymentScore = async (
    userid,
    accountverificationid,
    transactionreportid
  ) => {
    let url = `${process.env.REACT_APP_SERVER_URL}/tenants/calculatescore?tenantid=${userid}&accountverificationid=${accountverificationid}&transactionreportid=${transactionreportid}`;
    if (isGuarantor) {
      url += "&guarantor=true";
    }

    axiosInstanceInstance
      .get(url)
      .then((res) => {
        let serverResponse = res.data;
        if (serverResponse.status !== "success") {
          if (serverResponse.status == "pending") {
            getAnalysisDetails();
          } else {
            toast.error(_t("skorCanNotBeCalculated"));
          }
        }
        if (serverResponse.status === "success") {
          loadFullInfo(false);
        }
        const url = new URL(window.location);
        url.searchParams.delete("account_verification_report_id");
        url.searchParams.delete("transaction_report_id");
        window.history.replaceState(
          {},
          document.title,
          url.pathname + url.search
        );
      })
      .catch(() => {});
  };
  const clearPaymentData = async (tenantid) => {
    return new Promise((resolve) => {
      let url = `${process.env.REACT_APP_SERVER_URL}/tenants/algoan-info?tenantid=${tenantid}`;
      if (isGuarantor) {
        url += "&guarantor=true";
      }
      axiosInstance
        .delete(url)
        .then((res) => {
          return resolve(true);
        })
        .catch((err) => {
          let err_res = err;
          toast.error(err_res.message);
          return resolve(null);
        });
    });
  };
  // bank account connectivity handling ends

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const shouldOpen = params.get("uploadDocModel") === "true";

    if (shouldOpen) {
      setUploadDocModel(true);

      params.delete("uploadDocModel");
      navigate(
        { pathname: location.pathname, search: params.toString() },
        { replace: true }
      );
    }
  }, [location, navigate]);

  useEffect(() => {
    loadFullInfo();
  }, [location.search]);

  useEffect(() => {
    if (
      haveValue(user) &&
      haveValue(user?.tenant_extra_field_id?.forensic_analysis)
    ) {
      const kycDetails = getIdentityDetails(user, user?.onfido_user_kyc);
      const allReports =
        user?.tenant_extra_field_id?.forensic_analysis?.profileReports ?? [];
      setForensicRawData(allReports);

      let matchedReport;

      if (haveValue(kycDetails.value)) {
        matchedReport =
          allReports.find((report) =>
            report?.report?.keyFactors?.keyFactors?.some((kf) => {
              if (!kf?.dataInJSON || typeof kycDetails?.value !== "string")
                return false;

              let expectedKey;
              if (kycDetails.type?.toLowerCase() === "dni") {
                expectedKey = "dni";
              } else if (kycDetails.type?.toLowerCase() === "passport") {
                expectedKey = "passportNumber";
              } else {
                return false; // type not supported
              }

              const fieldValue = kf?.dataInJSON?.[expectedKey];
              return (
                typeof fieldValue === "string" &&
                fieldValue.toLowerCase() === kycDetails.value.toLowerCase()
              );
            })
          ) || allReports[0];
      } else {
        matchedReport = allReports[0];
      }

      const temp_data = matchedReport?.report;
      const temp_key = {};
      temp_data?.keyFactors?.keyFactors.map((val) => {
        temp_key[val.keyFactor] = val;
      });
      const doc_list = {};
      (temp_data?.documents_list ?? []).map((val) => {
        doc_list[val?.document_id] = val;
      });
      setForensicAnalysis(temp_key);
      setDocsMap(doc_list);
    }
  }, [user]);

  useEffect(() => {
    // financial income source get logic below
    const user_financial_income_sources = isGuarantor
      ? fullInfoForGurantor?.selected_financial_income_sources
      : fullinfo?.selected_financial_income_sources;
    setselectedFinancialIncomeSourceData(user_financial_income_sources);
    // financial income source get logic above
  }, [fullInfoForGurantor, fullinfo]);

  useEffect(() => {
    const user_income_sources = isGuarantor
      ? fullInfoForGurantor?.income_selection
      : fullinfo?.income_selection;
    const fallbackIncome = isGuarantor
      ? fullInfoForGurantor?.useFallbackIncome
      : fullinfo?.useFallbackIncome;
    const useFallbackIncome =
      typeof fallbackIncome === "boolean" ? fallbackIncome : true;

    const incomeSource = resolveIncomeSelection(user_income_sources, user?._id);

    // const gurantor_income_sources = user_income_sources?.guarantor_sources;
    let profile_effort_rate_percentage = isGuarantor
      ? fullInfoForGurantor?.effort_rate_data?.guarantor?.[user?._id]
          ?.effort_rate_percentage
      : fullinfo?.effort_rate_data?.tenant?.effort_rate_percentage;
    if (llShowOnly && !haveValue(profile_effort_rate_percentage)) {
      profile_effort_rate_percentage =
        originalUser?.current_workspace?.default_effort_rate ?? 35;
    }

    // user income
    const user_income = getCustomIncomeDetails(
      user,
      originalUser,
      _t,
      isGuarantor
        ? incomeSource?.guarantor_sources?.[user?._id]
        : incomeSource?.tenant_source,
      !llShowOnly,
      useFallbackIncome, // need Fallback
      deaWorkspace,
      fullinfo?.custom_income_sources
    );

    setUserIncome(user_income);

    let totalGurantorIncome = 0;
    let totalGurantorIncomeForReport = 0;
    let allGurantorIncomes = [];
    let allGurantors = user?.gurantor_id;
    const reportGuarantorIdsSet =
      typeof reportGuarantorIds === "string"
        ? new Set(reportGuarantorIds.split(",").filter(haveValue))
        : null;

    if (Array.isArray(allGurantors)) {
      allGurantors.forEach((gurantor) => {
        if (haveValue(gurantor)) {
          const income = getCustomIncomeDetails(
            gurantor,
            originalUser,
            _t,
            incomeSource?.guarantor_sources?.[gurantor?._id],
            !llShowOnly,
            useFallbackIncome, // need Fallback
            deaWorkspace,
            fullinfo?.custom_income_sources
          );
          if (
            [isGuarantor ? "tenant" : "guarantor", "both"]?.includes(
              effortRateType
            ) ||
            showEffortRateCalcuator
          ) {
            totalGurantorIncome += income?.amount || 0;
          }
          if (
            !reportGuarantorIdsSet ||
            reportGuarantorIdsSet.has(gurantor?._id?.toString())
          ) {
            totalGurantorIncomeForReport += income?.amount || 0;
          }
          allGurantorIncomes.push(income);
        }
      });
    }

    setGurantorsIncome(allGurantorIncomes);
    setTotalGuarantorIncome(totalGurantorIncome);

    const userAmount =
      [isGuarantor ? "guarantor" : "tenant", "both"]?.includes(
        effortRateType
      ) || showEffortRateCalcuator
        ? +user_income?.amount
        : 0;

    const userAmountForReport = user_income?.amount;

    const combinedIncome = userAmount + +totalGurantorIncome;
    const combinedIncomeForReport =
      userAmountForReport + +totalGurantorIncomeForReport;
    setCombinedIncome(combinedIncome);

    setUserMaxRent((prev) => ({
      ...prev,
      [user?._id]: combinedIncomeForReport ?? 0,
    }));

    if (showEffortRateCalcuator) {
      let temp_obj = calculateEffortRate(
        combinedIncome,
        originalUser,
        fullinfo
      );
      setEffortObj(temp_obj);
    } else {
      let temp_obj = calculateEffortRatePercentageTenant(
        combinedIncome,
        user,
        profile_effort_rate_percentage,
        llShowOnly
      );
      setEffortObj(temp_obj);
    }
  }, [
    user,
    fullinfo,
    fullInfoForGurantor,
    effortRateType,
    showEffortRateCalcuator,
    reportGuarantorIds,
  ]);

  const loadFullInfo = async (needLoading = true) => {
    if (needLoading) {
      setLoading(true);
    }

    if (haveValue(guarantor_id)) {
      const temp_data = {
        user_id: guarantor_id,
      };
      loadSharedProfileData("guarantorSide");
      getAllData(temp_data, "tenant")
        .then((res) => {
          const temp = { tenantid: res.tenant };
          setFullinfo(temp);
          setUser(temp?.tenantid);
          setForensicAnalysis(null);
          if (needLoading) {
            setLoading(false);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      await loadSharedProfileData();
    }
  };

  const resolveApplicationParticipant = (sharedProfile) => {
    const isApplication =
      sharedProfile?.application_id?.participants?.length > 0;
    if (!isApplication) {
      console.log("[SkorList2] Not an application, using tenantid:", {
        sharedProfileId: sharedProfile?._id,
        tenantName:
          `${sharedProfile?.tenantid?.fname || ""} ${sharedProfile?.tenantid?.lname || ""}`.trim(),
        participantTenantId: participantTenantId || null,
      });
      return { fullinfo: sharedProfile, user: sharedProfile?.tenantid };
    }

    console.log("[SkorList2] Application detected:", {
      sharedProfileId: sharedProfile?._id,
      participantsCount: sharedProfile.application_id.participants.length,
      participants: sharedProfile.application_id.participants.map((p) => ({
        id: p.id || p.tenant_info?._id,
        name: `${p.tenant_info?.fname || ""} ${p.tenant_info?.lname || ""}`.trim(),
        consent_status: p.consent_status,
        hasTenantInfo: !!p.tenant_info,
      })),
      participantTenantId,
    });

    if (participantTenantId) {
      const participant = sharedProfile.application_id.participants.find(
        (p) => p.tenant_info?._id === participantTenantId
      );
      if (participant?.tenant_info) {
        console.log("[SkorList2] Using application participant:", {
          participantId: participant.tenant_info._id,
          participantName:
            `${participant.tenant_info.fname || ""} ${participant.tenant_info.lname || ""}`.trim(),
          hasIncomeSelection: !!participant.income_selection,
        });
        return {
          fullinfo: {
            ...sharedProfile,
            tenantid: participant.tenant_info,
            tenant_id: participant.tenant_info,
            income_selection:
              resolveIncomeSelection(
                sharedProfile.income_selection,
                participantTenantId
              ) ||
              participant.income_selection ||
              sharedProfile.income_selection,
          },
          user: participant.tenant_info,
        };
      }
    }

    console.log(
      "[SkorList2] No participantTenantId match, falling back to tenantid"
    );
    return { fullinfo: sharedProfile, user: sharedProfile?.tenantid };
  };

  const loadSharedProfileData = async (calledFrom = null) => {
    if (haveValue(sharedprofileid)) {
      await axiosInstance
        .get(
          `${
            process.env.REACT_APP_SERVER_URL
          }/shared-profile/singleshared/${sharedprofileid}?landlordId=${localStorage.getItem(
            "saveduserid"
          )}`,
          {
            headers: {
              "Accept-Language": localStorage.getItem("i18nextLng"),
            },
          }
        )
        .then((res) => {
          let server_res = res;
          const sharedProfile = server_res.data.singleSharedProfile;

          if (sharedProfile?.tenantid?.ie_details_id) {
            sharedProfile.tenantid.ie_verified = checkIeDetails(
              sharedProfile?.tenantid
            );
          }

          console.log("[SkorList2] loadSharedProfileData (sharedprofileid):", {
            sharedprofileid,
            hasApplicationId: !!sharedProfile?.application_id,
            participantsCount:
              sharedProfile?.application_id?.participants?.length || 0,
            participantTenantId: participantTenantId || null,
          });

          const resolved = resolveApplicationParticipant(
            sharedProfile,
            calledFrom
          );

          if (calledFrom === "guarantorSide") {
            setFullInfoForGurantor(resolved.fullinfo);
          } else {
            setFullinfo(resolved.fullinfo);
            setUser(resolved.user);
          }
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
          toast.error(err.message);
        });
    }
    if (haveValue(agencylink)) {
      await axiosInstance
        .get(
          `${
            process.env.REACT_APP_SERVER_URL
          }/shared-profile/agency-shared/${agencylink}?landlordId=${localStorage.getItem(
            "saveduserid"
          )}`,
          {
            headers: {
              "Accept-Language": localStorage.getItem("i18nextLng"),
            },
          }
        )
        .then((res) => {
          let server_res = res;
          const sharedProfile = server_res.data.singleSharedProfile;

          if (sharedProfile?.tenantid?.ie_details_id) {
            sharedProfile.tenantid.ie_verified = checkIeDetails(
              sharedProfile?.tenantid
            );
          }

          console.log("[SkorList2] loadSharedProfileData (agencylink):", {
            agencylink,
            hasApplicationId: !!sharedProfile?.application_id,
            participantsCount:
              sharedProfile?.application_id?.participants?.length || 0,
            participantTenantId: participantTenantId || null,
          });

          const resolved = resolveApplicationParticipant(
            sharedProfile,
            calledFrom
          );

          if (calledFrom === "guarantorSide") {
            setFullInfoForGurantor(resolved.fullinfo);
          } else {
            setFullinfo(resolved.fullinfo);
            setUser(resolved.user);
          }
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
          toast.error(err.message);
        });
    }
    if (usertype === "tenant") {
      await loadUserTenant(usertype);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (usertype === "tenant") {
      // loadPendingGuarantees();
      if (
        haveValue(guarantor_id) &&
        ((Array.isArray(originalUser?.gurantor_for) &&
          originalUser?.gurantor_for.some(
            (item) => item?._id === guarantor_id
          )) ||
          (Array.isArray(originalUser?.gurantor_id) &&
            originalUser?.gurantor_id.some(
              (item) => item?._id === guarantor_id
            )) ||
          (Array.isArray(originalUser?.gurantor_added_id) &&
            originalUser.gurantor_added_id.some(
              (item) => item?.guarantor_id?._id === guarantor_id
            )))
      ) {
        const temp_data = {
          user_id: guarantor_id,
        };
        getAllData(temp_data, "tenant")
          .then((res) => {
            setUser(res.tenant);
            setForensicAnalysis(null);
            setLoading(false);
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        setFullinfo({ tenant_id: originalUser });
        setUser(originalUser);
      }
    }
  }, [originalUser]);

  const handleRentPercSave = (val) => {
    setLoading(true);
    const data = {
      shared_profile_id: haveValue(props?.sharedprofileid)
        ? props?.sharedprofileid
        : queryParameters.get("sharedprofileid") || null,
      agencylink: haveValue(props?.agencylink)
        ? props?.agencylink
        : queryParameters.get("agencylink") || null,
      rent_percentage: val,
    };
    saveRentPercentage(data)
      .then((res) => {
        loadFullInfo();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleSaveEffortRateData = async (data) => {
    const payload = {
      type: data.type,
      data: {
        effort_rate_percentage: data?.effort_rate_percentage,
        effort_rate_type: data?.effort_rate_type,
      },
      tenant_id: data?.tenant_id,
    };

    if (llShowOnly) {
      const profileId =
        fullinfo?.tenant_id?.profileId ?? agencylink ?? sharedprofileid;

      const profileOf =
        haveValue(agencylink) || fullinfo?.tenant_id?.profileOf === "agency"
          ? "agency"
          : "sharedProfile";

      payload.target_type = isGuarantor ? "guarantor" : "tenant";
      payload.guarantor_id = isGuarantor ? guarantor_id : null;
      payload.source = profileId;
      payload.profileOf = profileOf;
    }

    await saveEffortRateData(payload);
  };

  const handleInfoModal = (data) => {
    setInfoModal(data);
    setOpenInfoModal(true);
  };

  const handleIncomeChange = async (
    source,
    isGuarantor,
    guarantorId,
    customIncomes = []
  ) => {
    const id = fullinfo?.tenant_id?.profileId ?? agencylink ?? sharedprofileid;
    const profileOf =
      haveValue(agencylink) || fullinfo?.tenant_id?.profileOf === "agency"
        ? "agency"
        : "sharedProfile";

    let updatedSource = source;
    const tempToRealIdMap = {};

    if (customIncomes.length > 0) {
      const tenantId = fullinfo?.tenantid?._id;
      const targetType = isGuarantor ? "guarantor" : "tenant";
      const guarantorIdValue = isGuarantor ? guarantorId : null;

      for (const inc of customIncomes) {
        const res = await addCustomIncomeSource(id, {
          tenantid: tenantId,
          target_type: targetType,
          guarantor_id: guarantorIdValue,
          custom_source: {
            name: inc.title,
            amount: Number(inc.amount) || 0,
            description: inc.title,
          },
        });

        if (res?.status === "success") {
          tempToRealIdMap[inc.sourceKey] = `custom_income:${inc.title}`;
        }
      }

      if (Array.isArray(updatedSource)) {
        updatedSource = updatedSource.map((key) => tempToRealIdMap[key] || key);
      }
    }

    const payload = {
      target_type: isGuarantor ? "guarantor" : "tenant",
      guarantor_id: isGuarantor ? guarantorId : null,
      source: updatedSource,
      profileOf,
      tenantid: tenant_id ?? fullinfo?.tenantid?._id,
    };

    return changeIncomeSource(id, payload);
  };

  const handleDeleteCustomIncome = async (customSourceId, userType, userId) => {
    const id = fullinfo?.tenant_id?.profileId ?? agencylink ?? sharedprofileid;
    const tenantId = fullinfo?.tenantid?._id;
    const targetIsGuarantor = userType === "guarantor" || isGuarantor;
    const specificGuarantorId =
      targetIsGuarantor && userId ? userId : guarantor_id;
    const payload = {
      tenantid: tenantId,
      target_type: targetIsGuarantor ? "guarantor" : "tenant",
      guarantor_id: targetIsGuarantor ? specificGuarantorId : undefined,
    };
    const res = await deleteCustomIncomeSource(id, customSourceId, payload);
    if (res?.status === "success") {
      await loadFullInfo();
    }
  };

  const handleFinancialIncomeChange = async (
    sources,
    isGuarantor,
    guarantorId
  ) => {
    // This function is used to change the income source from financial information (tink)
    const id = fullinfo?.tenant_id?.profileId ?? agencylink ?? sharedprofileid;
    const profileOf =
      haveValue(agencylink) || fullinfo?.tenant_id?.profileOf === "agency"
        ? "agency"
        : "sharedProfile";

    const payload = {
      target_type: isGuarantor ? "guarantor" : "tenant",
      guarantor_id: isGuarantor ? guarantorId : null,
      sources,
      profileOf,
    };

    changeFinancialIncomeSource(id, payload)
      .then((res) => {
        if (res?.status === "success") {
          loadFullInfo(false);
        }
      })
      .catch(() => {
        toast.error(_t("failedToChangeFinancialIncomeSource"));
      })
      .finally(() => {
        setUpdateIncomeSourceModal(false);
      });
  };

  const [updateSourceObj, setUpdateSourceObj] = useState({
    _id: "",
    all_sources: {},
    current_selected: "",
  });

  const [currentLang, setCurrentLang] = useState(
    localStorage.getItem("i18nextLng").toLowerCase() || "en-us"
  );

  useEffect(() => {
    setCurrentLang(localStorage.getItem("i18nextLng").toLowerCase() || "en-us");
  }, [localStorage.getItem("i18nextLng")]);

  useEffect(() => {
    if (
      user?.bank_status &&
      !haveValue(user?.paymentScores) &&
      haveValue(user?.algoanCustomerId) &&
      haveValue(user?.algoanAnalysisId)
    ) {
      getAnalysisDetails();
    }
  }, [user]);

  const getAnalysisDetails = async (req, res) => {
    let userid = localStorage.getItem("saveduserid");
  };

  const loadPendingGuarantees = async (data) => {
    setPendingRequestsGuranteesLoading(true);
    try {
      const response = await getPendingGuaantees(data);
      setPendingGuaranteesRequests(response?.success_res ?? []);
    } catch (e) {
      console.error(e);
      toast.error(
        _t(
          "failedToLoadPendingRequests",
          "Text used in guarantees pending requests popup"
        )
      );
    } finally {
      setPendingRequestsGuranteesLoading(false);
    }
  };
  const { pathname } = useLocation();

  const hideContainer =
    pathname.includes("generatedReport") ||
    pathname.includes("report-overview") ||
    pathname.includes("capacity-report") ||
    pathname.includes("linked-report-overview");

  if (loading) return <Loader />;
  return (
    <>
      <div
        className={`wrapper-modal d-flex align-items-center justify-content-end ${
          showChatBot ? "chatbot-visible" : "chatbot-hidden"
        }`}
        onClick={(e) => setShowChatBot(false)}
      >
        <div
          onClick={(e) => e.stopPropagation()}
          className="skorlite-chatbot-div"
        >
          <div className="skorlite-chatbot-header">
            <div>
              <img className="animated-image" src={SkorAi} alt="Vector Icon" />
              <p>{_t("askSkor", "Chatbot Iframe thing")}</p>
            </div>
            <img
              src="/images/cancel-green.svg"
              className="cursor-pointer"
              alt=""
              onClick={(e) => setShowChatBot(false)}
            />
          </div>
          {showChatBot && (
            <iframe
              src={`${process.env.REACT_APP_SKOR_LITE_URL}${currentLang}/chat/${user?._id}`}
              frameborder="0"
              className="chatbot-iframe"
            />
          )}
        </div>
      </div>

      <div
        className={` ${
          hideContainer
            ? "main-page-wrapper main-page-wrapper-tenant"
            : "main-page-wrapper"
        } mb-4 position-relative reportWrapper`}
      >
        <TenantDetailsHeader
          user={user}
          fullinfo={fullinfo}
          forensicAnalysis={forensicAnalysis}
          userIncome={userIncome}
          setShowDefaulterCheck={setShowDefaulterCheck}
          totalIncomeModal={totalIncomeModal}
          setOpenGuarantorModel={setOpenGuarantorModel}
          setTotalIncomeModal={setTotalIncomeModal}
          setUpdateSourceObj={setUpdateSourceObj}
          updateSourceObj={updateSourceObj}
          showReportIcons={showReportIcons}
          handleUpdateSource={() => {
            setTotalIncomeModal(false);
            setUpdateIncomeSourceModal(true);
          }}
          isFromReport={true}
          isGuarantor={isGuarantor}
          llShowOnly={llShowOnly}
        />
        {showReportIcons && llShowOnly && (
          <>
            <div class="megadropdown summarymenu">
              <button
                class="megadropdown-toggle absolute_div d-flex align-items-center justify-content-center gap-1 profile-summary-button"
                type="button"
                onMouseEnter={() => setIsOpen(true)}
              >
                <p>{_t("profileSummary")}</p>
                <img class="icon" src="/images/icon-down-white.svg" alt="" />
              </button>
              <div
                class={`megadropdown-menu wrapper-modal ${
                  isOpen ? "open" : ""
                }`}
              >
                <div className="profile-summary-wrapper">
                  <div
                    className="main_summary"
                    onMouseLeave={() => setIsOpen(false)}
                  >
                    <h5 className="modal-head-summary">
                      {_t("profileSummary")}
                    </h5>
                    <div className="modal-body">
                      <div className="summary_content">
                        <span
                          dangerouslySetInnerHTML={{
                            __html: nl2ul(
                              localStorage.getItem("i18nextLng") === "es"
                                ? user?.profileSummaryEs
                                : user?.profileSummary,
                              "two-column-list"
                            ),
                          }}
                        />
                      </div>
                    </div>
                    <div className="disclaimer_div">
                      <p>
                        <strong>{_t("disclaimer")}:</strong>
                        {_t(
                          "summaryGeneratedByAiThroughSkorAiDataInformationMayBeProneToError",
                          "Disclaimer text"
                        )}
                      </p>
                    </div>
                    {user?.about_me && (
                      <div>
                        <h5 className="modal-head-summary tenant-input-content">
                          {_t("tenantInputContext")}
                        </h5>
                        <div className="summary_content">
                          <p className="summary_content_para">
                            {" "}
                            {user?.about_me}
                          </p>
                        </div>
                      </div>
                    )}
                    <div
                      onClick={(e) => setShowChatBot(true)}
                      className="d-flex items-center justify-content-end cursor-pointer"
                    >
                      <img
                        className="Skor_ai_logo flex-shrink-0"
                        src={SkorAi2}
                        alt="Vector Icon"
                      />
                    </div>
                  </div>
                </div>
                <div
                  style={{ width: "100%", height: "20%" }}
                  onMouseLeave={() => setIsOpen(false)}
                ></div>
              </div>
            </div>
          </>
        )}
        <div
          className={`Profile_summary ${hideContainer && "mt-0"} ${
            !llShowOnly ? "tenant_Profile_summary" : ""
          }`}
        >
          <DetailsSkor
            user={user}
            combinedIncome={combinedIncome}
            effortObj={effortObj}
            handleSaveEffortRateData={handleSaveEffortRateData}
            loadFullInfo={loadFullInfo}
            userIncome={userIncome}
            gurantorsIncome={gurantorsIncome}
            handleIncomeChange={handleIncomeChange}
            totalIncomeModal={totalIncomeModal}
            setTotalIncomeModal={setTotalIncomeModal}
            showReportIcons={showReportIcons}
            handleFinancialIncomeChange={handleFinancialIncomeChange}
            selectedFinancialIncomeSourceData={
              selectedFinancialIncomeSourceData
            }
            selectedSources={selectedSources}
            setSelectedSources={setSelectedSources}
            isGuarantor={isGuarantor}
            paymentScoreLoading={paymentScoreLoading}
            setPaymentScoreLoading={setPaymentScoreLoading}
            Bankshow={Bankshow}
            setBankshow={setBankshow}
            reconnectFlow={reconnectFlow}
            setReconnectFlow={setReconnectFlow}
            updateTenantData={updateTenantData}
            scoreValue={scoreValue}
            setScoreValue={setScoreValue}
            getAnalysisDetails={getAnalysisDetails}
            financial_info_errors={financial_info_errors}
            setFinancial_info_errors={setFinancial_info_errors}
            profileId={
              fullinfo?.tenant_id?.profileId ?? agencylink ?? sharedprofileid
            }
            excluded_income_source_ids={
              fullinfo?.excluded_income_source_ids ?? []
            }
            effortRateType={effortRateType}
            setEffortRateType={setEffortRateType}
            totalGuarantorIncome={totalGuarantorIncome}
            showEffortRateCalcuator={showEffortRateCalcuator}
            setShowEffortRateCalcuator={setShowEffortRateCalcuator}
            fullinfo={fullinfo}
            fullInfoForGurantor={fullInfoForGurantor}
            guarantor_id={guarantor_id}
            llShowOnly={llShowOnly}
          />
        </div>
        <div className="mt-3">
          <div className="row align-items-stretch">
            <div className="col-md-6">
              <DetailsPersonalInfo
                user={user}
                forensicAnalysis={forensicAnalysis}
                handleInfoModal={handleInfoModal}
                currentLang={currentLang}
                llShowOnly={llShowOnly}
              />
            </div>
            <div className="col-md-6">
              <DetailsEmploymentInfo
                user={user}
                isFromReport={true}
                forensicAnalysis={forensicAnalysis}
                handleInfoModal={handleInfoModal}
                currentLang={currentLang}
                llShowOnly={llShowOnly}
              />
            </div>
            <div className="col-md-12">
              <DetailsIncomeInfo
                user={user}
                forensicAnalysis={forensicAnalysis}
                handleInfoModal={handleInfoModal}
                isFromReport={true}
                llShowOnly={llShowOnly}
              />
            </div>
          </div>
          <DetailsDocs
            user={user}
            setClaveDocs={setClaveDocs}
            setVerifiedDocs={setVerifiedDocs}
            forensicRawData={forensicRawData}
            forensicAnalysis={forensicAnalysis}
            uploadDocModel={uploadDocModel}
            setUploadDocModel={setUploadDocModel}
            isGuarantor={isGuarantor}
            isFromReport={true}
            currentLang={currentLang}
            llShowOnly={llShowOnly}
            isDeaRulesActivated={isDeaRulesActivated}
          />
        </div>
        {/* <div className="addGuarantorButtonWrapper d-flex align-items-center justify-content-end homePageFooter">
          <button className="addGuarantorButton">
            {_t("submit")}
          </button>
        </div> */}
        {showReportIcons && llShowOnly && (
          <div
            onClick={(e) => setShowChatBot(true)}
            className="SkorAI_logo cursor-pointer"
          >
            <img className="animated-image" src={SkorAi} alt="Vector Icon" />
          </div>
        )}
        {llShowOnly && (
          <div className="profile-summary-wrapper">
            <div className="main_summary mainSummary">
              <h5 className="modal-head-summary">{_t("profileSummary")}</h5>
              <div className="modal-body">
                <div className="summary_content">
                  <span
                    dangerouslySetInnerHTML={{
                      __html: nl2ul(
                        localStorage.getItem("i18nextLng") === "es"
                          ? user?.profileSummaryEs
                          : user?.profileSummary,
                        "two-column-list"
                      ),
                    }}
                  />
                </div>
              </div>
              <div className="disclaimer_div">
                <p>
                  <strong>{_t("disclaimer")}:</strong>
                  {_t(
                    "summaryGeneratedByAiThroughSkorAiDataInformationMayBeProneToError",
                    "Disclaimer text"
                  )}
                </p>
              </div>
              {user?.about_me && (
                <div>
                  <h5 className="modal-head-summary tenant-input-content">
                    {_t("tenantInputContext")}
                  </h5>
                  <div className="summary_content">
                    <p className="summary_content_para"> {user?.about_me}</p>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
      <DataInfoModal
        isOpen={openInfoModal}
        onClose={() => setOpenInfoModal(false)}
        infoModal={infoModal}
        handleUpdateSource={() => {
          setOpenInfoModal(false);
          setUpdateIncomeSourceModal(true);
        }}
        claveDocs={claveDocs}
        verifiedDocs={verifiedDocs}
        docsMap={docsMap}
        forensicAnalysis={forensicAnalysis}
      />
      {showDefaulterCheck && (
        <DefaultCheckReportModal
          isOpen={showDefaulterCheck}
          onClose={(e) => setShowDefaulterCheck(false)}
          user={user}
        />
      )}
      {updateIncomeSourceModal && (
        <UpdatedIncomeSourceModal
          show={updateIncomeSourceModal}
          onHide={() => {
            setUpdateIncomeSourceModal(false);
            // setTotalIncomeModal(true);
          }}
          updateSourceList={updateSourceObj}
          handleIncomeChange={handleIncomeChange}
          loadFullInfo={loadFullInfo}
          savedCustomSources={fullinfo?.custom_income_sources}
          handleDeleteCustomIncome={handleDeleteCustomIncome}
        />
      )}

      <GuarantorDetails
        isOpen={openGuarantorModel}
        onClose={() => {
          setOpenGuarantorModel(false);
        }}
        user={user}
        effortObj={effortObj}
        userIncome={userIncome}
        gurantorsIncome={gurantorsIncome}
        setUpdateSourceObj={setUpdateSourceObj}
        showReportIcons={showReportIcons}
        llShowOnly={llShowOnly}
        isGuarantor={(user?.gurantor_for?.length ?? 0) > 0 ?? isGuarantor}
      />
      <PendingRequestsPopup
        handleAcceptModal={() => setIsAcceptModalOpen(true)}
        show={pendingGuaranteesRequests.length > 0}
        pendingGuarantees={pendingGuaranteesRequests}
        loadPendingGuarantees={loadPendingGuarantees}
        loading={pendingRequestsGuranteesLoading}
        setLoading={setPendingRequestsGuranteesLoading}
        setPendingGuaranteesRequests={setPendingGuaranteesRequests}
        setAcceptedGuaranteeName={setAcceptedGuaranteeName}
      />
      <RequestAcceptingModal
        show={isAcceptModalOpen}
        onClose={() => setIsAcceptModalOpen(false)}
        acceptedGuaranteeName={acceptedGuaranteeName}
      />
    </>
  );
}

export default SkorList2;
